export default __webpack_public_path__ + "locales/ar-SA/SalesDepartmentRequestDialog.json?hash=360b4b617d62bcf8f14de7a4781f31d4";